import { CloudOff } from 'lucide-react'
import { useOnlineStatus } from '../hooks/useOnlineStatus'

/** Subtle banner shown while the browser is offline (PWA read-only mode). */
export function OfflineWarning() {
  const online = useOnlineStatus()
  if (online) return null
  return (
    <div
      role="status"
      className="flex items-center justify-center gap-2 bg-st-accent/15 px-4 py-1.5 text-xs font-medium text-st-accent-700"
    >
      <CloudOff className="h-3.5 w-3.5" />
      You’re offline — showing your last saved trip details.
    </div>
  )
}
